module.exports = __webpack_public_path__ + "202408221624/img/home_iomic_avatar.871219ee.png";